import { ThemeProvider } from '@emotion/react';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { theme } from '../theme';
import { AppHome } from './pages/app-home/AppHome';
import { Home } from './pages/home/Home';

export const App = () => (
  <ThemeProvider theme={theme}>
    <Switch>
      <Route component={AppHome} exact={true} path="/:appId" />
      <Route component={Home} exact={true} path="/" />
    </Switch>
  </ThemeProvider>
);

export default App;
